<template>
  <!-- eslint-disable vue/no-multiple-template-root -->
  <NuxtPwaManifest />

  <v-app>
    <v-layout>
      <v-navigation-drawer
        v-model="leftDrawerOpen"
        color="grey-darken-3"
        :rail="miniDrawer && $vuetify.display.smAndUp"
        :permanent="miniDrawer && $vuetify.display.smAndUp"
        name="nav-drawer"
      >
        <template #prepend>
          <v-list-item height="64px">
            <v-toolbar-title v-if="!miniDrawer">SAM {{ $t("admin.title") }}</v-toolbar-title>
            <v-toolbar-title v-else class="text-center">S</v-toolbar-title>

            <template #append>
              <v-app-bar-nav-icon
                v-if="!miniDrawer && $vuetify.display.smAndUp"
                variant="text"
                icon="chevron_left"
                @click="
                  () => {
                    miniDrawer = true
                    leftDrawerOpen = true
                  }
                "
              />
            </template>
          </v-list-item>
        </template>

        <template #default>
          <admin-layout-side-menu :rail="miniDrawer && $vuetify.display.smAndUp" />
        </template>
      </v-navigation-drawer>

      <v-app-bar>
        <v-app-bar-nav-icon v-if="$vuetify.display.xs" icon="menu" @click="() => (leftDrawerOpen = !leftDrawerOpen)" />
        <v-app-bar-nav-icon
          v-else-if="miniDrawer || !leftDrawerOpen"
          icon="menu"
          @click="
            () => {
              miniDrawer = false
              leftDrawerOpen = true
            }
          "
        />

        <v-toolbar-title v-if="breadcrumbs.length && $vuetify.display.mdAndUp">
          <v-breadcrumbs
            class="px-0 navigation-breadcrumbs"
            :items="
              breadcrumbs.map((breadcrumb, index, self) => ({
                ...breadcrumb,
                title: self.length - 1 === index ? title : $i18n.t(breadcrumb.title),
                disabled: self.length - 1 === index,
              }))
            "
          />
        </v-toolbar-title>
        <v-toolbar-title v-else>{{ title }}</v-toolbar-title>

        <template #append>
          <admin-add-menu />

          <v-menu :close-on-content-click="false">
            <template #activator="{ props }">
              <v-btn icon="account_circle" v-bind="props" />
            </template>

            <template #default="{ isActive }">
              <header-menu @close="() => (isActive.value = false)" />
            </template>
          </v-menu>
          <div id="header-menu-backdrop-target" />
        </template>

        <template v-if="tabs.length > 0" #extension>
          <v-tabs :key="tabsKey" v-model="selectedTab" :class="$vuetify.display.mdAndUp ? 'px-4' : ''">
            <v-tab v-for="tab in tabs" :key="tab.value" :value="tab.value" :prepend-icon="tab.icon" class="text-none">
              {{ $te(tab.label) ? $t(tab.label) : tab.label }}
            </v-tab>
          </v-tabs>
        </template>
      </v-app-bar>

      <v-main scrollable name="main-content">
        <inner-loading :showing="pending" />

        <slot v-if="!pending" />

        <snackbar-toaster :snackbars="snackbars" />
      </v-main>

      <div id="add-menu-backdrop-target" />
    </v-layout>
  </v-app>
</template>

<script setup lang="ts">
import { useDisplay } from "vuetify"

const display = useDisplay()
const $route = useRoute()
const $i18n = useI18n()

const userStore = useUserStore()
const authStore = useAuthStore()
const mainStore = useMainStore()

const { organizations } = storeToRefs(authStore)
const { snackbars } = storeToRefs(mainStore)

const { miniDrawer } = useUserPreferences()

useThemeWatcher()

const leftDrawerOpen = ref(display.lgAndUp.value)

const { pending } = useAsyncData(
  async () => {
    const { _id } = await userStore.getCurrentUser()
    await authStore.fetchScopes({ user: _id, object: organizations.value[0]! })
  },
  { immediate: true },
)

const { computedTitle: title } = useRouteTitle()

const breadcrumbs = computed<Array<BreadcrumbItem>>(() =>
  $route.meta.breadcrumbs && Array.isArray($route.meta.breadcrumbs) ? $route.meta.breadcrumbs : [],
)

const { tabs, selectedTab, tabsKey } = useTabs()
</script>

<style>
.navigation-breadcrumbs .v-breadcrumbs-item--disabled {
  opacity: inherit;
}
</style>
